import { render, staticRenderFns } from "./PermohonanProvChart.vue?vue&type=template&id=0c37bd5e&"
import script from "./PermohonanProvChart.vue?vue&type=script&lang=js&"
export * from "./PermohonanProvChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports